var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-dialog',{staticClass:"modal-lg",attrs:{"id":"destination-dialog","show":_vm.shown,"dismissable":true},on:{"update:show":function($event){_vm.shown=$event}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.title))]},proxy:true}])},[_c('PortalTarget',{attrs:{"name":"destination-modal-destination"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }